export default __webpack_public_path__ + "static/media/seafood_cat.dbdcb6d6.jpg";